import React, { useEffect, useState, useRef } from "react";
import api from "@/lib/api";

// El anuncio se renderiza solo cuando (1) hay un ID de AdSense válido y (2) el administrador
// ha activado los anuncios. El consentimiento GDPR lo gestiona la CMP certificada de Google
// (Consent Mode v2): AdSense no mostrará anuncios personalizados hasta que el usuario acepte.
export default function AdSlot({ label = "Espacio publicitario", slot }) {
  const [cfg, setCfg] = useState(null);
  const insRef = useRef(null);
  const pushed = useRef(false);

  useEffect(() => {
    api.get("/site-config").then(({ data }) => setCfg(data)).catch(() => setCfg({ ads_enabled: false }));
  }, []);

  const ready = cfg && cfg.ads_enabled && cfg.adsense_client_id;

  useEffect(() => {
    if (ready && !pushed.current) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        pushed.current = true;
      } catch (e) { console.error("AdSense push failed:", e); }
    }
  }, [ready]);

  if (!ready) return null;
  return (
    <div data-testid="ad-slot" className="my-8">
      <span className="block text-[10px] uppercase tracking-widest text-muted-foreground mb-1">{label}</span>
      <ins ref={insRef} className="adsbygoogle" style={{ display: "block" }}
        data-ad-client={cfg.adsense_client_id}
        {...(slot ? { "data-ad-slot": slot } : {})}
        data-ad-format="auto" data-full-width-responsive="true" />
    </div>
  );
}
